module.exports = __webpack_public_path__ + "static/media/doctor.9d7d198d.png";